import * as amplitude from '@amplitude/analytics-browser'
import { LOCATION_SERVER } from '../constants/LOCATION'

const AMPLITUDE_KEY = '24076b8f6c6d80c42ff6b1e5da5ead74'

//doc https://www.docs.developers.amplitude.com/data/sdks/typescript-browser/#custom-user-id
amplitude.init(AMPLITUDE_KEY, undefined, {
  defaultTracking: {
    sessions: true,
    pageViews: true,
    formInteractions: true,
    fileDownloads: true,
  },
  //proxy config on the server - /etc/nginx/conf.d/prod.api.aspectapp.io.conf (in amplitude endpoint)
  serverUrl: `${LOCATION_SERVER}/amplitude`,
  minIdLength: 1,
})

class Logger {
  trackEvent = (name: LOG_NAME, params?: Record<string, any>) => {
    amplitude.track(name, params)
  }

  setUserId = (userId: string) => {
    amplitude.setUserId(String(userId || ''))
  }

  public setSessionUserProperty = (
    props: {
      key: string
      value: amplitude.Types.ValidPropertyType | undefined
    }[],
  ) => {
    if (!props?.length) {
      return
    }
    const identifyEvent = new amplitude.Identify()
    props.forEach((prop) => {
      if (!prop?.value) {
        return
      }
      identifyEvent.set(prop.key, prop.value)
    })
    amplitude.identify(identifyEvent)
  }
}

export enum LOG_NAME {
  open_report = 'open_report',
  sales_button_press = 'sales_button_press',
}

const logger = new Logger()

export default logger
